<template>
    <div class="my-3 col-12">
        <draggable
            v-if="links.length"
            :list="links"
            handle=".handle"
            @start="drag = true"
            @end="drag = false"
        >
            <div
                v-for="(link, index) in links"
                :key="index"
                class="card flex-row col-12 py-1 my-2 bg-light text-center align-items-center d-flex"
                :class="{ 'error-border': v.$each[index].$error }"
            >
                <button class="handle btn btn-info">
                    <i class="fas fa-arrows-alt" />
                </button>

                <button class="mx-3 btn btn-danger" @click="deleteLink(index)">
                    <i class="far fa-trash-alt" />
                </button>
                <div
                    class="justify-content-center align-items-center"
                    style="flex: 1"
                    dir="auto"
                >
                    {{ link.text }}
                </div>
                <button class="btn btn-success" @click="editLink(index)">
                    <i class="far fa-edit" />
                </button>
            </div>
        </draggable>

        <div v-else class="d-flex justify-content-center my-3">
            No links added yet!
        </div>

        <div class="d-flex justify-content-center">
            <button
                class="btn btn-info waves-effect waves-light my-2"
                type="button"
                @click="addLink"
            >
                <i class="fas fa-plus-circle" /> Add new link
            </button>
        </div>

        <edit-link-modal
            :link="linkToEdit"
            :modal-id="modalId"
            @input="onLinkEdited"
        />
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import EditLinkModal from '@/components/header/EditLinkModal';

export default {
    components: {
        Draggable,
        EditLinkModal
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        v: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            links: [...this.value],
            linkToEdit: null,
            editedIndex: null,
            drag: false,
            modalId:
                'edit-link-modal' +
                Math.random()
                    .toString(36)
                    .substring(2, 15)
                    .match(/[a-zA-Z]+/g)
                    .join('')
        };
    },

    watch: {
        links: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        }
    },

    methods: {
        onLinkEdited(link) {
            this.links[this.editedIndex] = link;

            this.$emit('input', this.links);

            this.editedIndex = null;
            this.linkToEdit = null;
        },

        editLink(index) {
            this.editedIndex = index;
            this.linkToEdit = this.links[index];

            this.$bvModal.show(this.modalId);
        },

        deleteLink(index) {
            this.links.splice(index, 1);
        },

        addLink() {
            this.links.push({ text: '', redirect: '' });

            this.editLink(this.links.length - 1);
        }
    }
};
</script>
